import { APIUserSlice } from 'store/api/user';
import { designInputsOf, useIsNewDesignOf } from 'utils/impersonationDesign';

/**
 * Whether the new design is on, read from the cache rather than through `useUiDesign`: the layout holds
 * every page until the current user has loaded, so no component under it has a reason to start that
 * query itself. The tenant's flag applies as it does there, and so does a design chosen while impersonating.
 * It selects the plain values the answer hangs on, never the user: a list calls this once per row.
 */
export const useIsNewDesign = () =>
    useIsNewDesignOf(
        APIUserSlice.endpoints.getUserData.useQueryState(undefined, {
            selectFromResult: ({ data }) => designInputsOf(data),
        })
    );
